export default {
  "content": "<g clip-path=\"url(#a)\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M7.209 13.897c0 .507.415.922.922.922a.925.925 0 00.922-.922V8.363h5.534a.925.925 0 00.923-.923.925.925 0 00-.922-.922H9.053V.984A.925.925 0 008.131.06a.925.925 0 00-.922.923v5.534H1.674a.925.925 0 00-.922.922c0 .508.415.923.922.923H7.21v5.534z\" fill=\"currentColor\"/></g><defs><clipPath id=\"a\"><path fill=\"#fff\" transform=\"translate(.752 .061)\" d=\"M0 0h14.758v14.758H0z\"/></clipPath></defs>",
  "attrs": {
    "width": "16",
    "height": "15",
    "viewBox": "0 0 16 15",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};